import React from 'react';
import PSPDFKitWeb from 'pspdfkit';
import SnippetNameForm from 'components/pspdf/components/snippet-name-editor/components/snippet-name-form';
import { Selection } from 'components/pspdf/components/selection';
import { renderToString } from 'react-dom/server';

import { ServerStyleSheet } from 'styled-components';

const sheet = new ServerStyleSheet();

interface ShowNameEditorInput {
  selectedAnnotation: { current: any };
  instance: any;
  callbacks: {
    onTextSnippetSave: (data: any) => void;
    onTextSnippetDelete: (data: any) => void;
  };
}

interface HideNameEditorInput {
  instance: any;
}

export async function showNameEditor({
  selectedAnnotation,
  instance,
  callbacks,
}: ShowNameEditorInput) {
  const selection = new Selection(selectedAnnotation.current, instance);
  const selectionRect = await selection.getRect();
  const position = calculatePosition(selectionRect.rect);
  const node = document.createElement('div');

  const html = renderToString(
    sheet.collectStyles(
      <SnippetNameForm
        parentNode={node}
        value={selection.getCustomData('name')}
        onTextSnippetSave={callbacks.onTextSnippetSave}
        onTextSnippetDelete={callbacks.onTextSnippetDelete}
        selection={selection}
        hideForm={() => hideNameEditor({ instance })}
      />,
    ),
  );

  const styleTags = sheet.getStyleTags();

  node.innerHTML = styleTags + html;

  const element = new PSPDFKitWeb.CustomOverlayItem({
    id: 'NameEditor',
    node,
    position,
    pageIndex: selectionRect.pageIndex,
    onAppear,
  });

  const nodeClassName = 'cortlex-snippet-name-form';

  node?.classList.add(nodeClassName);

  function onAppear() {
    setTimeout(() => {
      const [element] =
        instance.contentDocument.getElementsByClassName(nodeClassName) ?? [];

      if (element && element?.parentElement?.parentElement) {
        const parentParent = element?.parentElement
          ?.parentElement as HTMLElement;

        if (parentParent) {
          parentParent.style.position = 'fixed';
        }
      }
    });
  }

  instance.setCustomOverlayItem(element);
}

export function hideNameEditor({ instance }: HideNameEditorInput) {
  try {
    instance.removeCustomOverlayItem('NameEditor');
  } catch {
    //Nothing
  }
}

function calculatePosition(rect: any) {
  const position = rect.getLocation();

  return new PSPDFKitWeb.Geometry.Point({
    x: position.x - 10,
    y: position.y + rect.height / 2 - 30,
  });
}
